import {ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, input, Input, OnDestroy, OnInit, output, Signal, ViewChild} from '@angular/core';
import {DialogRecherchePlatsSupplier, MenusPlanning2Service} from '../../../core/services/gestionmenus/menus-planning2.service';
import {CelluleTableauDTO} from '../../../core/dtos/gestionmenus/planning/cellule-tableau-dto';
import {UtilsService} from '../../../core/utils/utils.service';
import {MenuCompositionDTO} from '../../../core/dtos/menucomposition-dto';
import {MSG_KEY, MSG_SEVERITY, SEARCH_PLATS_TYPE_DIALOG, USER_PREFERENCE} from '../../../core/constants';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {PreferencesUtilisateurService} from '../../../core/services/preferences-utilisateur.service';
import {MenuItem, TreeNode} from 'primeng/api';
import * as moment from 'moment';
import {DecoupageRepasDTO} from '../../../core/dtos/decoupagerepas-dto';
import {RepasDTO} from '../../../core/dtos/repas-dto';
import {Subscription} from 'rxjs';
import {MenuDragdropService} from '../../../core/services/gestionmenus/menu-dragdrop.service';
import {MenusToolbarService} from '../../../core/services/gestionmenus/menus-toolbar.service';
import {Table} from 'primeng/table';
import {Menu} from "primeng/menu";
import {ContratmenuDTO} from "../../../core/dtos/contratmenu-dto";
import {ToastService} from "../../../core/services/technique/toast.service";
import {RegimeAlimentaireDTO} from "../../../core/dtos/regime-alimentaire-dto";
import {Saisonnalite} from "../../../core/dtos/saisonnalite";
import {CdkDragDrop, CdkDragEnter, CdkDragSortEvent} from "@angular/cdk/drag-drop";

@Component({
    selector: 'yo-decoupage-repas2',
    templateUrl: './decoupage-repas2.component.html',
    styleUrls: ['./decoupage-repas2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DecoupageRepas2Component implements OnInit, OnDestroy {

  subPreferences: Subscription;
  displayCoutsUnitairesPonderes = false;
  displayAnalyseFinanciere = false;
  displayCoutsUnitaires = false;
  displayAppellations = false;
  displayAllergenes = false;
  displayFamillesGemrcn = false;
  displayTauxDePrise = false;
  slots: any[] = [];
  hoveringOccupied = false;

  decoupageRepasToDisplayList: TreeNode[] = [];
  subDecoupageRepasDisplaySettings: Subscription;
  hasToDisplay: boolean = true;

  itemsMenuDecoupage: MenuItem[] = [];
  itemsMenuComposition: MenuItem[] = [];

  contratMenuSelected: ContratmenuDTO;
  regimeSelected: RegimeAlimentaireDTO;

  subContratMenuSelected: Subscription;
  subRegimeSelected: Subscription;

  connectedDropLists: Signal<string[]> = input<string[]>([]);
  dropCompleted = output<void>();
  dropListId = computed(() => {
    const dateKey = this.cellule?.dateMenu
      ? moment(this.cellule.dateMenu).format('YYYYMMDD')
      : '0';
    return `drop-list-${this.cellule?.repasId}-${this.cellule?.idContratMenuConviveDecoupage}-${dateKey}`;
  });

  @Input('cellule') cellule: CelluleTableauDTO;
  @ViewChild('table') table: Table;
  @ViewChild('menuDecoupage') menuDecoupage: Menu;
  @ViewChild('menuMenuComposition') menuMenuComposition: Menu;

  #menuDragDropSvc: MenuDragdropService = inject(MenuDragdropService);

  constructor(public mp2Svc: MenusPlanning2Service,
              private cd: ChangeDetectorRef,
              public auth2Svc: Auth2Service,
              public utils: UtilsService,
              private prefUserSvc: PreferencesUtilisateurService,
              public menuToolbarSvc: MenusToolbarService,
              private menusToolbarSvc: MenusToolbarService,
              private toastSvc: ToastService) {
  }


  ngOnInit() {
    this.allSubscription();
    this.cellule.changeDetector = this.cd;

    // Callback pour permettre la mise à jour depuis l'extérieur
    this.cellule.updateSlots = (newSlots: any[]) => {
      this.slots = [...newSlots];
      this.cd.markForCheck();
    };

    this.slots = this.mp2Svc.getSlots(this.cellule);
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subPreferences);
    this.utils.unsubscribe(this.subDecoupageRepasDisplaySettings);
    this.utils.unsubscribe(this.subContratMenuSelected);
    this.utils.unsubscribe(this.subRegimeSelected);
    this.menusToolbarSvc.editAllergenesAppellationsMc.set(undefined);
  }

  allSubscription = () => {
    this.subContratMenuSelected = this.menuToolbarSvc.contratMenuSelected$.subscribe(contratMenu => {
      this.contratMenuSelected = contratMenu;
    });

    this.subRegimeSelected = this.menusToolbarSvc.regime$.subscribe(regime => this.regimeSelected = regime);

    this.subPreferences = this.prefUserSvc.preferencesOfUser$.subscribe(item => {
      this.setVisibilityInformation();
      this.cd.markForCheck();
    });

    // affichage decoupage repas
    this.subDecoupageRepasDisplaySettings = this.mp2Svc.decoupageRepasDisplaySettings$.subscribe(data => {
      this.decoupageRepasToDisplayList = data;
      this.hasToDisplayBody(this.cellule);
    })
  };

  getMenuComposition = (cellule: CelluleTableauDTO, idxChoix: number): MenuCompositionDTO => {
    return this.mp2Svc.getMenuComposition(cellule, idxChoix);
  }

  deleteMenuComposition = (menuComposition: MenuCompositionDTO, ordre: number) => {
    const ids = [menuComposition.id];
    this.mp2Svc.deleteMenusCompositions(ids).subscribe(response => {
      if (!this.utils.isResponseSupplierError(response)) {
        delete this.cellule.mapMenuComposition[ordre];
        this.mp2Svc.calculCoutUnitairePondere(this.cellule);
        this.mp2Svc.calculCoutUnitaireTotal(this.cellule);
        this.cd.markForCheck();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le plat ${menuComposition.produitDeclinaisonLibelle} a été retiré du menu`);
      }
    });
  };

  deleteMenusCompositions = (): void => {
    const ids: number[] = [];
    if (!this.utils.isNullOrEmpty(this.cellule)) {
      if (this.cellule.mapMenuComposition) {
        Object.keys(this.cellule.mapMenuComposition).forEach(key => {
          const val = this.cellule.mapMenuComposition[key];
          if (!this.utils.isNullOrEmpty(val)) {
            ids.push(val.id);
          }
        });
      }
      this.mp2Svc.deleteMenusCompositions(ids).subscribe(response => {
        if (!this.utils.isResponseSupplierError(response)) {
          Object.keys(this.cellule.mapMenuComposition).forEach(key => delete this.cellule.mapMenuComposition[key]);
          this.mp2Svc.calculCoutUnitairePondere(this.cellule);
          this.mp2Svc.calculCoutUnitaireTotal(this.cellule);
          this.cd.markForCheck();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Les plats ont été supprimés avec succès sur la composante repas '${this.cellule.libelleDecoupageRepas}'`);
        }
      });
    }
  };

  showDialogRecherchePlats = (event: any) => {
    if (this.auth2Svc.isSiteLocal(this.cellule.contratMenuSiteId)) {
      this.cellule.changeDetector = this.cd;
      let count = 0;
      Object.keys(this.cellule.mapMenuComposition).forEach(key => {
        if (!this.utils.isNullOrEmpty(this.cellule.mapMenuComposition[key])) {
          count++;
        }
      });
      if (count === this.cellule.choixMax) {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Le nombre de plats maximum a été atteint pour ${this.cellule.libelleDecoupageRepas} ${this.cellule.libelleRepas} ${this.cellule.libelleConvive} ${this.utils.getFrenchDateDDMMYYYY(moment(this.cellule.dateMenu))}. Veuillez supprimer un plat avant de réaliser une recherche`);
      } else {
        const inputs = this.inputsForSearch(this.cellule);
        this.mp2Svc.announceInputRecherchePlats(inputs);
      }
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Vous ne pouvez pas modifier le menu. Vous n'avez pas les droits sur cet environnement`);
    }
  };

  inputsForSearch = (cell: CelluleTableauDTO): DialogRecherchePlatsSupplier => {
    const dr = new DecoupageRepasDTO();
    dr.libelle = cell.contratMenuConviveDecoupage.decoupageRepasLibelle;
    dr.id = cell.contratMenuConviveDecoupage.decoupageRepasId;

    const repas = new RepasDTO();
    repas.libelle = cell.libelleRepas;
    repas.id = cell.repasId;

    const inputsSearch = new DialogRecherchePlatsSupplier();
    inputsSearch.cmcd = cell.contratMenuConviveDecoupage;
    inputsSearch.dateMenu = moment(cell.dateMenu).toDate();
    inputsSearch.decoupageRepas = dr;
    inputsSearch.repas = repas;
    inputsSearch.choixMax = cell.choixMax;
    inputsSearch.maxItemsPanier = this.mp2Svc.getMaxItemsPanier(cell);
    inputsSearch.cmcContrainteAlim = this.mp2Svc.planningMenus.contrainteAlimentaire;
    inputsSearch.prestation = this.mp2Svc.planningMenus.contratMenuConviveList[0];
    inputsSearch.searchMode = this.prefUserSvc.getPreferenceUtilisateurIntValue(USER_PREFERENCE.GESTIONMENUS_RECHERCHE_MODE);
    inputsSearch.sourceObject = cell;
    inputsSearch.famillesGemRcn = cell.famillesGemrcn;
    inputsSearch.regimeAlimentaire = this.regimeSelected;
    // 1 = menus compositions, 2 = menus compositions plc
    inputsSearch.typeDialog = SEARCH_PLATS_TYPE_DIALOG.MENUS;

    return inputsSearch;
  };

  /**
   * Modifiable si
   */
  canModify = (): boolean => {
    if (!this.utils.isNullOrEmpty(this.cellule)) {
      return this.auth2Svc.isSiteLocal(this.cellule.contratMenuSiteId);
    }
    return false;
  };

  isDisabled = (siteId: number, nonModifiable: boolean): boolean => {
    const isDisabled = !this.auth2Svc.isSiteLocal(siteId);
    return isDisabled || nonModifiable;
  };

  /**
   * Indique si le drag and drop est autorisé. Le drag and drop est autorisé si et seulement si
   * le site du ContratMenu sélectionné est le site principal de l'utilisateur connecté.
   * @returns {boolean}
   */
  isDragEnabled = (): boolean => {
    return this.auth2Svc.isSiteLocal(this.cellule.contratMenuSiteId);
  };

  isCopyMode = (): boolean => this.#menuDragDropSvc.isCopyMode;

  /**
   * Nombre de colonnes réellement rendues par une ligne de plat : la colonne libellé, plus une
   * colonne par bloc conditionnel (l'analyse financière en rend deux : prix de vente et marge).
   * Doit rester aligné sur les <th> de l'entête et les <td> du corps : ce colspan est appliqué
   * aux lignes de créneau vide et au placeholder de drag, donc tout écart désaligne la grille
   * entière (allergènes et appellations se retrouvant sous la mauvaise entête).
   */
  getColspan = (): number => {
    let colspan = 1;

    if (this.displayFamillesGemrcn) {
      colspan++;
    }

    if (this.displayAppellations) {
      colspan++;
    }

    if (this.displayAllergenes) {
      colspan++;
    }

    if (this.displayTauxDePrise) {
      colspan++;
    }

    if (this.displayTauxDePrise) {
      colspan++;
    }

    if (this.displayCoutsUnitaires) {
      colspan++;
    }

    if (this.displayCoutsUnitairesPonderes) {
      colspan++;
    }

    if (this.displayAnalyseFinanciere) {
      colspan += 2;
    }

    return colspan;
  };

  hasToDisplayBody = (cellule: CelluleTableauDTO) => {
    let result: TreeNode = this.decoupageRepasToDisplayList
      .find(item => item.data.niveau === 2 && item.data.idRepas === cellule.repasId && item.data.libelleDecoupageRepas === cellule.libelleDecoupageRepas);
    this.hasToDisplay = !this.utils.isNullOrEmpty(result);
    this.cd.markForCheck();
  };

  initItemsMenuDecoupageAndDisplay = (event: any) => {
    this.itemsMenuDecoupage = [
      {
        label: 'Supprimer tous les plats de ' + this.cellule.libelleDecoupageRepas,
        icon: 'fas fa-sync-alt',
        disabled: !this.canModify(),
        command: (event) => this.deleteMenusCompositions()
      }];
    this.menuDecoupage.toggle(event);
  };

  initItemsMenuCompositionAndDisplay = (event, cellule: CelluleTableauDTO, menuComposition: MenuCompositionDTO, ordre: number) => {
    this.itemsMenuComposition = [
      {
        label: 'Informations',
        icon: 'fas fa-info fa-sm space',
        command: (event) => this.menuToolbarSvc.openInfosMenuCompo(menuComposition, cellule)
      },
      {
        label: 'Enlever le plat',
        icon: 'fas fa-trash fa-sm space',
        disabled: this.isDisabled(cellule.contratMenuSiteId, cellule.nonModifiable),
        command: (event) => this.deleteMenuComposition(menuComposition, ordre)
      },
      {
        label: 'Modifier les allergènes et appellations du plat',
        icon: 'fas fa-tags fa-sm space',
        command: (event) => this.menuToolbarSvc.openEditAllergenesAppellationsMenuCompo(menuComposition)
      }
    ];
    this.menuMenuComposition.toggle(event);
  }

  setVisibilityInformation = () => {
    this.displayTauxDePrise = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_TAUX_DE_PRISE);
    this.displayAppellations = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_APPELLATIONS);
    this.displayAllergenes = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_ALLERGENES);
    this.displayFamillesGemrcn = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_FAMILLES_GEMRCN);

    if (!this.utils.isNullOrEmpty(this.contratMenuSelected)) {
      this.displayCoutsUnitaires = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_COUTS_UNITAIRES);
      this.displayCoutsUnitairesPonderes = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_COUTS_UNITAIRES_PONDERES);
      this.displayAnalyseFinanciere = this.prefUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_ANALYSE_FINANCIERE);
    } else {
      this.displayCoutsUnitaires = !this.menuToolbarSvc.isLockedContratMenu(this.contratMenuSelected)
      this.displayCoutsUnitairesPonderes = !this.menuToolbarSvc.isLockedContratMenu(this.contratMenuSelected)
      this.displayAnalyseFinanciere = !this.menuToolbarSvc.isLockedContratMenu(this.contratMenuSelected)
    }
  };


  getRangeDayMonth(saisonnalite: Saisonnalite) {
    return this.utils.getDayMonth(saisonnalite.start) + ' - ' + this.utils.getDayMonth(saisonnalite.end);
  }

  onDrop(event: CdkDragDrop<any[]>) {
    const result = this.#menuDragDropSvc.isCopyMode
      ? this.#menuDragDropSvc.duplicateMenuCompositionOnTable(event, this.cellule)
      : this.#menuDragDropSvc.moveMenuCompositionOnTable(event, this.cellule);
    if (!result) return;

    this.cellule = result.targetCellule;
    this.slots = result.slots;
    result.sourceCellule.changeDetector?.markForCheck();
    result.targetCellule.changeDetector?.markForCheck();
    this.hoveringOccupied = false;
    this.dropCompleted.emit();
    this.mp2Svc.planningMenus.changeDetector?.markForCheck();
    this.cd.markForCheck();
  }

  onDragEntered(event: CdkDragEnter<any[]>) {
    this.hoveringOccupied = this.isSlotOccupied(event.currentIndex);
    this.cd.markForCheck();
  }

  onDragExited() {
    this.hoveringOccupied = false;
    this.cd.markForCheck();
  }

  onListSorted(event: CdkDragSortEvent<any[]>) {
    this.hoveringOccupied = this.isSlotOccupied(event.currentIndex);
    this.cd.markForCheck();
  }

  private isSlotOccupied(index: number): boolean {
    const slot = this.slots[index];
    return slot != null && !this.utils.isNullOrEmpty(this.mp2Svc.getMenuComposition(this.cellule, slot.idxSlot));
  }
}
